// @ts-nocheck
import React, { useState } from "react";
import Leftbar from "../layout/Leftbar";
import Topbar from "../layout/Topbar";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import { PostApi } from "../../../ApiClient/PostApi";
import useFetch from "../../../ApiClient/GetApi";
import { Loader2 } from "../../loader/Loader";

export default function Profile() {
  const { data, reFetch } = useFetch("admin_profile");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    password: "",

    confirmPassword: "",
  });
  const [loading, SetLoading] = useState(false);
  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const update_profile = async () => {
    // if(formData.firstName === "" || formData.firstName === null)
    // {
    //   error_toaster("First Name is required");
    //   return false;
    // }
    // if(formData.lastName === "" || formData.lastName === null)
    // {
    //   error_toaster("Last Name is required");
    //   return false;
    // }
    // if(formData.phone === "" || formData.phone === null)
    // {
    //   error_toaster("PHone No. is required");
    //   return false;
    // }
    // if(formData.email === "" || formData.email === null)
    // {
    //   error_toaster("Email is required");
    //   return false;
    // }
    // if(formData.password === "" || formData.password === null)
    // {
    //   error_toaster("Password is required");
    //   return false;
    // }
    // if(formData.confirmPassword === "" || formData.confirmPassword === null)
    // {
    //   error_toaster("Confirmed Password is required");
    //   return false;
    // }
    SetLoading(true);
    const res = await PostApi("update_profile", {
      firstName:
        formData.firstName === "" ? data?.data?.firstName : formData.firstName,
      lastName:
        formData.lastName === "" ? data?.data?.lastName : formData.lastName,
      phone: formData.phone === "" ? data?.data?.phone : formData.phone,
      email: formData.email === "" ? data?.data?.email : formData.email,
      password: formData.password,
      confirmPassword: formData.confirmPassword,
    });

    if (res.data.status === "1") {
      success_toaster(res.data.message);
      SetLoading(false);
      empty_input_fields();
      reFetch()
    } else {
      error_toaster(res.data.message);
      SetLoading(false);
    }
  };
  const empty_input_fields = () => {
    setFormData({
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      password: "",
      confirmPassword: "",
    });
  };

  return (
    <>
      <Leftbar />
      <Topbar main="Update Profile" extend={false} />
      <section className="relative xl:w-[calc(100%-280px)] w-[calc(100%-240px)] top-[148px] py-5 px-10 float-right space-y-8">
        {loading ? (
          <Loader2 />
        ) : (
          <div className="bg-white p-10 space-y-6">
            <p className="text-lg text-gray-500 font-semibold">
              General Information
            </p>
            <div className="grid grid-cols-2 gap-x-5 gap-y-4">
              <div className="space-y-2">
                <div>
                  <label>First Name</label>
                </div>
                <input
                  onChange={onChange}
                  name="firstName"
                  value={formData.firstName}
                  className="py-3 px-8 bg-themeGray3 focus:outline-gray-200 w-full"
                  placeholder={data?.data?.firstName ?? ""}
                />
              </div>
              <div className="space-y-2">
                <div>
                  <label>Last name</label>
                </div>

                <input
                  onChange={onChange}
                  name="lastName"
                  value={formData.lastName}
                  className="py-3 px-8 bg-themeGray3 focus:outline-gray-200 w-full"
                  placeholder={data?.data?.lastName ?? ""}
                />
              </div>

              <div className="space-y-2">
                <div>
                  <label>Phone no</label>
                </div>

                <input
                  onChange={onChange}
                  value={formData.phone}
                  name="phone"
                  className="py-3 px-8 bg-themeGray3 focus:outline-gray-200 w-full"
                  placeholder={data?.data?.phone ?? ""}
                />
              </div>

              <div className="space-y-2">
                <div>
                  <label>Email</label>
                </div>
                <input
                  onChange={onChange}
                  name="email"
                  value={formData.email}
                  type="email"
                  className="py-3 px-8 bg-themeGray3 focus:outline-gray-200 w-full border-none focus:outline-none focus:ring-0"
                  placeholder={data?.data?.email ?? ""}
                />
              </div>
              <div className="space-y-2">
                <div>
                  <label>Password</label>
                </div>
                <input
                  onChange={onChange}
                  name="password"
                  value={formData.password}
                  type="password"
                  className="py-3 px-8 bg-themeGray3 focus:outline-gray-200 w-full border-none focus:outline-none focus:ring-0"
                  placeholder="******"
                />
              </div>
              <div className="space-y-2">
                <div>
                  <label>Confirm Password</label>
                </div>
                <input
                  onChange={onChange}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  type="password"
                  className="py-3 px-8 bg-themeGray3 focus:outline-gray-200 w-full border-none focus:outline-none focus:ring-0"
                  placeholder="*******"
                />
              </div>
            </div>
            <div className="flex gap-x-2 justify-end">
              <div>
                <button
                  onClick={empty_input_fields}
                  className="text-themeBlue rounded border border-themeBlue py-1 px-8 hover:text-white hover:bg-themeBlue"
                >
                  Reset
                </button>
              </div>
              <div>
                <button
                  onClick={update_profile}
                  className="bg-themeBlue text-white rounded py-1 px-8 border border-themeBlue hover:text-themeBlue hover:bg-white"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
}
